import Model from '@/models/BaseModel'
import i18n from '@/plugins/i18n'
import PlanPackage from '@/shared/models/plans/PlanPackage'
import Customer from '@/models/Customer'

export default class PlanProposal extends Model {
    resourceName() {
        return 'plan-proposals'
    }

    fields() {
        return [
            'id',
            'customer_id',
            'plan_package_id',
            'total_price',
            'final_price',
            'requested_at',
            'approved_at',
            'rejected_at',
            'expire_at',
            'consultant_name',
            'consultant_id',
            'corporate',
            'proposal_sent_at',
            'finalized_at',
            'plan_id',
            'url',
            'error_content',
            'proposal',
            'approved_proposal',
            'created_at',
            'updated_at',
            'deleted_at',
        ]
    }

    casts() {
        return {
            id: 'number',
            customer_id: 'number',
            plan_package_id: 'number',
            total_price: 'number',
            final_price: 'number',
            requested_at: 'any',
            approved_at: 'any',
            rejected_at: 'any',
            expire_at: 'any',
            consultant_name: 'string',
            consultant_id: 'number',
            corporate: 'boolean',
            proposal_sent_at: 'any',
            finalized_at: 'any',
            plan_id: 'number',
            url: 'string',
            error_content: 'any',
            proposal: 'any',
            approved_proposal: 'any',
            created_at: 'any',
            updated_at: 'any',
            deleted_at: 'any',
        }
    }

    relationships() {
        return {
            planPackage: new PlanPackage(),
            customer: new Customer(),
        }
    }

    dates() {
        return {
            requested_at: 'YYYY-MM-DD HH:mm:ss',
            approved_at: 'YYYY-MM-DD HH:mm:ss',
            rejected_at: 'YYYY-MM-DD HH:mm:ss',
            expire_at: 'YYYY-MM-DD HH:mm:ss',
            finalized_at: 'YYYY-MM-DD HH:mm:ss',
            proposal_sent_at: 'YYYY-MM-DD HH:mm:ss',
            created_at: 'YYYY-MM-DD HH:mm:ss',
            updated_at: 'YYYY-MM-DD HH:mm:ss',
            deleted_at: 'YYYY-MM-DD HH:mm:ss',
        }
    }

    computed() {
        return {
            expired(planProposal) {
                return (
                    planProposal.expire_at &&
                    planProposal.expire_at.isValid() &&
                    planProposal.expire_at.isBefore() &&
                    (!planProposal.approved_at ||
                        !planProposal.approved_at.isValid()) &&
                    (!planProposal.rejected_at ||
                        !planProposal.rejected_at.isValid())
                )
            },
            formattedRequestedAt(planProposal) {
                return planProposal.requested_at &&
                    planProposal.requested_at.isValid()
                    ? i18n.d(planProposal.requested_at, 'short')
                    : null
            },
            formattedApprovedAt(planProposal) {
                return planProposal.approved_at &&
                    planProposal.approved_at.isValid()
                    ? i18n.d(planProposal.approved_at, 'short')
                    : null
            },
            formattedRejectedAt(planProposal) {
                return planProposal.rejected_at &&
                    planProposal.rejected_at.isValid()
                    ? i18n.d(planProposal.rejected_at, 'short')
                    : null
            },
            formattedExpireAt(planProposal) {
                return planProposal.expire_at &&
                    planProposal.expire_at.isValid()
                    ? i18n.d(planProposal.expire_at, 'short')
                    : null
            },
            formattedFinalizedAt(planProposal) {
                return planProposal.finalized_at &&
                    planProposal.finalized_at.isValid()
                    ? i18n.d(planProposal.finalized_at, 'short')
                    : null
            },
            formattedProposalSentAt(planProposal) {
                return planProposal.proposal_sent_at &&
                    planProposal.proposal_sent_at.isValid()
                    ? i18n.d(planProposal.proposal_sent_at, 'short')
                    : null
            },
            formattedCreatedAt(planProposal) {
                return planProposal.created_at &&
                    planProposal.created_at.isValid()
                    ? i18n.d(planProposal.created_at, 'datetime')
                    : null
            },
            formattedUpdatedAt(planProposal) {
                return planProposal.updated_at &&
                    planProposal.updated_at.isValid()
                    ? i18n.d(planProposal.updated_at, 'datetime')
                    : null
            },
            formattedDeletedAt(planProposal) {
                return planProposal.deleted_at &&
                    planProposal.deleted_at.isValid()
                    ? i18n.d(planProposal.deleted_at, 'datetime')
                    : null
            },
            totalPrice(planProposal) {
                return i18n.n(planProposal.total_price, 'currency')
            },
            finalPrice(planProposal) {
                return i18n.n(planProposal.final_price, 'currency')
            },
            configPrice(planProposal) {
                return i18n.n(
                    planProposal.planPackage.config_price -
                        planProposal.final_price,
                    'currency',
                )
            },
            discountValue(planProposal) {
                return i18n.n(planProposal.proposal.discount, 'currency')
            },
        }
    }

    get isDeleted() {
        return !this.deleted_at || !this.deleted_at.isValid()
    }
}
